import { createPluginFactory } from '@udecode/plate-common';

import { withErrorHandling, withErrorReporting } from './withErrorHandling';

export const KEY_ERROR_HANDLING = 'error_handling';
export const KEY_ERROR_REPORTING = 'error_reporting';

/**
 * Enables support for deserializing inserted content from HTML format to Slate format.
 */
export const createErrorHandlingPlugin = createPluginFactory({
  key: KEY_ERROR_HANDLING,
  withOverrides: withErrorHandling,
});

/**
 * Enables support for catching errors occuring within event handlers.
 *
 * #TODO: This throws an error when tabbing through tables,
 * so this can be used. Need to figure out how to handle this.
 */
export const createErrorReportingPLugin = createPluginFactory({
  key: KEY_ERROR_REPORTING,
  withOverrides: withErrorReporting,
});
